import { Button, Col, Row, Image, List, Card, Switch, Form, Tooltip } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons'; 
import React, { useEffect, useState } from 'react'

import { recordError } from '../../../utils/logService';
import "../project-join/joinProject.css";

import service from '../../../services/citizenscienceService';
import { PlusOutlined, CheckCircleFilled, PauseCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import EditParticipant from '../participants/EditParticipant';

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export default function ProjectParticipants({data, setAcceptingParticipants, acceptingParticipants}) {

    let msg = "";
    var action = "Adding Participant";
    const [mergedRoles, setMergedRoles] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [participant, setParticipant] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [participantId, setParticipantId] = useState();
    const [projectId, setProjectId] = useState();
    const [projectUuid, setProjectUuid] = useState();
    const [projectStatus, setProjectStatus] = useState();
    const [formType, setFormType] = useState("Add");
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
      getParticipants();
    }, [data]);

    const getParticipants = async () => {
      const mergeRoles = [
        ...data?.rolesPreProject??[],
        ...data?.rolesDuringProject??[],
        ...data?.rolesPostProject??[],
      ];

      // only retrieve the first occurrence of an object using findindex
      const uniqueRoles = mergeRoles.filter(
        (role, index, self) =>
          index === self.findIndex((item) => item.key === role.key)
      );

      try {
        setProjectStatus(data.status);
        setProjectId(data.projectid);
        setProjectUuid(data.projectuuid);
        setMergedRoles(uniqueRoles);
        loadParticipants();
      } catch (error) {
        recordError(error);
      }
    };

    const onAddProjectParticipant = () => {
      setFormType("Add");
      setShowModal(true);
    };

    const handleCancel = () => {
      setShowModal(false);
    };

    const editParticipant = async (id) => {
      const projectuuid = data.projectuuid;
      setParticipantId(id);
      const result = await service.getParticipant(projectuuid, id);
      setParticipant(result.data);
      setFormType("Edit");
      setShowModal(true);
    };

    const loadParticipants = async () => {
      const projectid = data.projectid;
      const response = await service.getProjectDetails(projectid);

      if (response && response.status === 200) {
        const { data } = response;
        setParticipants(data.participants);
      } else {
        setParticipants([]);
      }
    };

    const handleModalSubmit = async (values) => {
      setSubmitted(true);
      try {
        
        const projectId = data.projectuuid;
        const participantData = {
          title: values.title.key,
          firstname: values.firstname,
          lastname: values.lastname,
          email: formType === "Edit" ? participant.email : values.email,
          contactNumber: values.contactNumber,
          disability:
            formType === "Edit"
              ? participant.disability.key
              : parseInt(values.disability),
          race:
            formType === "Edit" ? participant.race.key : parseInt(values.race),
          gender:
            formType === "Edit"
              ? participant.gender.key
              : parseInt(values.gender),
          ageGroup:
            formType === "Edit"
              ? participant.ageGroup.key
              : parseInt(values.ageGroup),
          type:
            formType === "Edit"
              ? participant.type.key
              : parseInt(values.participantType),
          location: {
            town:
              formType === "Edit"
                ? participant.location?.town?.key
                : parseInt(values.town),
            district:
              formType === "Edit"
                ? participant.location.district.key
                : parseInt(values.district),
            province:
              formType === "Edit"
                ? participant.location.province.key
                : parseInt(values.province),
          },
          roles: values.roles?.map((r) => parseInt(r)),
          motivations:
            formType === "Edit"
              ? values.motivations?.map((d) => d)
              : [], //   : values.motivations,
          status: values.status?.key ?? values.status,
        };

        let result = "";
        if (formType === "Add") {
          result = await service.addParticipant(participantData, projectId);
          action = "Adding Participant";
        } else {
          result = await service.editParticipant(
            participantData,
            projectId,
            participantId
          );
          action = "Editing Participant";
        }
        if (result?.status == 200 || result?.status == 201) {
          msg = util.parseMessage(Messages.ADD_SUCCESS, "Participant");
          openNotification(action, msg, Notify.SUCCESS);
          setShowModal(false);
          loadParticipants();
        } else {
          msg = util.parseMessage(Messages.ADD_FAILURE, "Participant");
          openNotification(action, msg, Notify.ERROR);
        }
      } catch (error) {
        if(error?.response.status === 409) {
          msg = util.parseMessage(Messages.USER_EXISTS);
        }
        else {
          
          msg = util.parseMessage(Messages.ADD_FAILURE, "Participant");
        }
        openNotification("Participant", msg, Notify.ERROR);
        recordError(error);
      }
      setSubmitted(false);
    };

    const getButtonLabel = (status) => {
      if (status == "Approved") {
        return "View/Edit";
      } else {
        return "View/Approve";
      }
    };

    const handleSwitchChange = async (checked) => {
      setAcceptingParticipants(checked);
      const projectId = data.projectuuid;
      var msg;

      try {
        const request = await service.getParticipnatsSwitch(projectId, checked);
        if (request && request.status === 200) {
          msg = util.parseMessage(Messages.UPDATE_SUCCESS, "Project Status ");
          openNotification("Project Status", msg, Notify.SUCCESS);
          return;
        }
        msg = util.parseMessage(Messages.UPDATE_FAILURE, "Project Status");
        openNotification("Project Status", msg, Notify.ERROR);
      } catch (error) {
        openNotification(
          "Project Status",
          "SYSTEM FAILED TO UPDATE",
          Notify.ERROR
        );
      }
    };

    return (
      <div className="">
        <Row>
          <Col xs={24}>
            <div className="public-portal-section">
              <h2> Citizen Science - {data.name}</h2>
            </div>
          </Col>
        </Row>
        <Col xs={24}>
          <h3 className="center-align">
            Project Status -{" "}
            <span style={{ color: data.statusColor }}>{data.status}</span>{" "}
          </h3>
        </Col>
        <Col xs={24} className="center-align">
          {data.status !== "Approved" && data.status !== "Closed" && (
            <span style={{ color: "blue", fontSize: "16px" }}>
              Project has not been approved. Participants cannot be added.
            </span>
          )}
        </Col>
        <Card bordered={false} headStyle={{ border: 0, textAlign: "center" }}>
          {(projectStatus === "Approved" || projectStatus === "Closed") && (
            <>
              <Row>
                <Col xs={4}>
                  <h3>
                    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    <b>Citizen Scientists</b>
                    <Tooltip
                      title="Select 'Yes' if the project is presently actively seeking new citizen scientists at any stage of the research process. Select 'No' if participation is presently limited or halted"
                      trigger="click"
                      placement="right"
                      overlayInnerStyle={{ maxWidth: 700, whiteSpace: 'normal' }}
                    >
                      <ExclamationCircleOutlined style={{ marginLeft: 8 }} />
                    </Tooltip>
                  </span>
                  </h3>
                </Col>
                <Col xs={8}>
                  <h3>
                    Accepting Citizen Scientists?{" "}
                    <Switch
                      checked={acceptingParticipants}
                      onChange={handleSwitchChange}
                      style={{ BackgroundColor: "#5599c8"}}
                      checkedChildren="Yes"
                      unCheckedChildren="No"
                    />
                  </h3>
                </Col>
                {projectStatus !== "Closed" && acceptingParticipants && (
                  <Col xs={8} md={12}>
                    <Button
                      key="1"
                      className="right-align-button add-button"
                      type="primary"
                      shape="round"
                      onClick={onAddProjectParticipant}
                      icon={<PlusOutlined />}
                    >
                      Add New Scientist
                    </Button>
                  </Col>
                )}
              </Row>

              <List
                itemLayout="vertical"
                pagination={{
                  pageSize: 5,
                }}
                dataSource={participants}
                renderItem={(participant) => (
                  <List.Item key={participant.id}>
                    <Card className="card-border">
                      <Row className="center-align">
                        <Col xs={24} md={24}>
                          {participant.status.value === "Approved" && (
                            <CheckCircleFilled style={{ color: "#2db83d" }} />
                          )}
                          {participant.status.value === "Submitted" && (
                            <PlusCircleFilled style={{ color: "#1F618D" }} />
                          )}
                          {participant.status.value === "Suspended" && (
                            <PauseCircleFilled style={{ color: "#bd8725" }} />
                          )}
                          <b> Status :</b> {participant.status.value}
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={2} md={2}>
                          <Image
                            src={require("../../../assets/baseline-account_circle-24px.png")}
                          />
                        </Col>
                        <Col xs={1} md={1}></Col>
                        <Col xs={21} md={21}>
                          <Row>
                            <Col xs={6} md={6}>
                              <b> Name:</b> {participant.firstName}{" "}
                              {participant.lastname}
                            </Col>
                            {projectStatus !== "Rejected" &&
                              projectStatus !== "Closed" && (
                                <Col xs={18} md={18}>
                                  <Button
                                    // size="small"
                                    type="primary"
                                    shape="round"
                                    className="right-align-button edit-button"
                                    onClick={() =>
                                      editParticipant(participant.uuid)
                                    }
                                  >
                                    {getButtonLabel(participant.status.value)}
                                  </Button>
                                </Col>
                              )}
                          </Row>
                          <Row>
                            <Col xs={4} md={4}>
                              <b>Contact Details:</b>
                            </Col>
                            <Col xs={8} md={8}>
                              <Image
                                src={require("../../../assets/phone.png")}
                              />{" "}
                              {participant.contactNumber}
                            </Col>
                            <Col xs={8} md={8}>
                              <Image
                                src={require("../../../assets/mail.png")}
                              />{" "}
                              {participant.email}
                            </Col>
                          </Row>
                          <Row>
                            <Col xs={16} md={16}>
                              <b>Roles:</b>{" "}
                              {participant.roles
                                .map((item) => `${item.value}`)
                                .join(", ")}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Card>
                  </List.Item>
                )}
              />
            </>
          )}
        </Card>
        <Row>
          <Col xs={24}>
            <EditParticipant
              data={participant}
              roles={mergedRoles}
              visible={showModal}
              onCancel={handleCancel}
              onModalSubmit={handleModalSubmit}
              formType={formType}
              loading = {submitted}
            />
          </Col>
        </Row>
      </div>
    );
}
